var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "combobox",
      style: { width: _vm.dataWidth },
      attrs: { "data-menu-id": _vm.menuId, dir: _vm.dir },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            $event.preventDefault()
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            )
              return null
            _vm.isOpen || !_vm.$refs.focusOnClickOpen
              ? _vm.focusDown()
              : _vm.doOpen(_vm.$refs.focusOnClickOpen)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            $event.preventDefault()
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            )
              return null
            return _vm.focusUp.apply(null, arguments)
          },
        ],
      },
    },
    [
      _vm.editable && _vm.multiple
        ? _c("input", {
            class: _vm.dataClass || "form-control",
            staticStyle: {
              "background-color": "#f2dede",
              "border-color": "#ebccd1",
              color: "#a94442",
            },
            style: _vm.dataStyle,
            attrs: {
              title:
                "Editable and Multiple are not supported on the same selectpicker!",
              value:
                "Editable and Multiple are not supported on the same selectpicker!",
              type: "text",
              disabled: "",
            },
          })
        : _vm.editable
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            ref: "focusOnEscClose",
            class: ["menu-input", _vm.dataClass || "form-control"],
            style: _vm.dataStyle,
            attrs: {
              type: "text",
              id: _vm.dataId,
              name: _vm.dataName,
              title: _vm.dataTitle,
              placeholder: _vm.placeholder || _vm.$attrs.title,
              disabled: _vm.disabled,
              dir: _vm.dir,
              autofocus: _vm.autofocus,
              autocomplete: _vm.autocomplete,
            },
            domProps: { value: _vm.inputValue },
            on: {
              focus: function ($event) {
                _vm.doOpen() /*call directly, don't pass focusIn event*/
              },
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  )
                    return null
                  _vm.doClose() /*focus shifts to next element, close menu*/
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  return _vm.doClose()
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.doClose()
                },
              ],
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.inputValue = $event.target.value
                },
                function ($event) {
                  $event.stopPropagation()
                  _vm.emitChangeOnClose = true
                },
              ],
              change: function ($event) {
                $event.stopPropagation()
              },
            },
          })
        : _c(
            "button",
            {
              ref: "focusOnEscClose",
              class: [
                "menu-button",
                "btn",
                _vm.dataClass || "btn-default",
                { active: _vm.isOpen },
              ],
              style: _vm.dataStyle,
              attrs: {
                type: "button",
                id: _vm.dataId,
                name: _vm.dataName,
                title: _vm.dataTitle,
                disabled: _vm.disabled,
                dir: _vm.dir,
                autofocus: _vm.autofocus,
              },
              on: {
                click: function ($event) {
                  _vm.isOpen
                    ? _vm.doClose()
                    : _vm.doOpen(_vm.$refs.focusOnClickOpen)
                },
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    )
                      return null
                    _vm.doClose() /*focus shifts to next element, close menu*/
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    )
                      return null
                    return _vm.doClose()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                    _vm.clickTarget(
                      $event
                    ) /*stop to prevent submitting any parent form*/
                  },
                ],
              },
            },
            [
              _vm.displayValues.length && _vm.showValues
                ? [
                    _vm.allowHtml
                      ? _c("span", {
                          staticClass: "menu-value",
                          attrs: { title: _vm.value + "" },
                          domProps: {
                            innerHTML: _vm._s(_vm.displayValues.join(", ")),
                          },
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "menu-value",
                            attrs: { title: _vm.displayValues.join(",") },
                          },
                          [_vm._v(_vm._s(_vm.displayValues.join(", ")))]
                        ),
                  ]
                : _c("span", { staticClass: "menu-value placeholder" }, [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(
                          _vm.placeholder ||
                            _vm.$attrs.title ||
                            (_vm.multiple
                              ? "Select values..."
                              : "Select a value...")
                        ) +
                        "\n\t\t"
                    ),
                  ]),
              _vm._v(" "),
              _vm.loading
                ? _c("span", {
                    staticClass: "menu-icon fa fa-spinner fa-spin text-muted",
                  })
                : !_vm.showValues && _vm.multiple && _vm.showValueCount
                ? _c(
                    "span",
                    {
                      class: [
                        "menu-icon badge",
                        { active: _vm.displayValues.length },
                      ],
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(
                            _vm.displayValues.length || _vm.totalOptionCount
                          ) +
                          "\n\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                class: [
                  "menu-icon",
                  "menu-caret",
                  "fa",
                  "fa-caret-down",
                  {
                    //'fa-rotate-180': isOpen
                    "fa-flip-vertical": _vm.isOpen,
                  },
                ],
              }),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isOpen && (_vm.filteredOptions.length || !_vm.editable),
              expression: "isOpen && (filteredOptions.length || !editable)",
            },
          ],
          ref: "menu",
          class: ["combobox-menu", _vm.computedMenuClass, _vm.dataMenuClass],
          attrs: { "data-menu-id": _vm.menuId, dir: _vm.dir },
          on: {
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape",
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                _vm.$refs.focusOnEscClose.focus()
                _vm.doClose() /* order is important */
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown",
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.focusDown.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "right", 39, $event.key, [
                    "Right",
                    "ArrowRight",
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                if ("button" in $event && $event.button !== 2) return null
                return _vm.focusDown.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp",
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.focusUp.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "left", 37, $event.key, [
                    "Left",
                    "ArrowLeft",
                  ])
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                if ("button" in $event && $event.button !== 0) return null
                return _vm.focusUp.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                $event.shiftKey ? _vm.focusUp() : _vm.focusDown()
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "page-down",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.focusOffset(10, false)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "page-up",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.focusOffset(-10, false)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "home",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.focus(0)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "end",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.focus(Number.MAX_SAFE_INTEGER)
              },
            ],
          },
        },
        [
          _c("li", { staticClass: "menu-header" }, [
            _vm.loading &&
            _vm.editable /* not visible in button when editable */
              ? _c("div", { staticClass: "text-center" }, [
                  _c("span", {
                    staticClass: "fa fa-spinner fa-spin text-muted",
                  }),
                ])
              : _vm._e(),
            _vm.resettable && _vm.filteredOptions.length
              ? _c(
                  "button",
                  {
                    class: [
                      "menu-button menu-reset",
                      "btn btn-sm",
                      _vm.dataClass || "btn-default",
                    ],
                    attrs: { type: "button", tabindex: "-1" },
                    on: {
                      click: function ($event) {
                        _vm.internalModel = {}
                        _vm.inputValue = ""
                      },
                    },
                  },
                  [_vm._v("Reset")]
                )
              : _vm._e(),
            _vm.searchable &&
            !_vm.editable /* When it's available, edit box handles searching */
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputValue,
                      expression: "inputValue",
                    },
                  ],
                  ref: "focusOnClickOpen",
                  staticClass: "form-control input-sm menu-search",
                  attrs: {
                    type: "text",
                    placeholder: "Filter...",
                    tabindex: "-1",
                    dir: _vm.dir,
                  },
                  domProps: { value: _vm.inputValue },
                  on: {
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "left", 37, $event.key, [
                            "Left",
                            "ArrowLeft",
                          ])
                        )
                          return null
                        $event.stopPropagation()
                        if ("button" in $event && $event.button !== 0)
                          return null
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "right", 39, $event.key, [
                            "Right",
                            "ArrowRight",
                          ])
                        )
                          return null
                        $event.stopPropagation()
                        if ("button" in $event && $event.button !== 2)
                          return null
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "home",
                            undefined,
                            $event.key,
                            undefined
                          )
                        )
                          return null
                        $event.stopPropagation()
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "end",
                            undefined,
                            $event.key,
                            undefined
                          )
                        )
                          return null
                        $event.stopPropagation()
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        _vm.filteredOptions.length < 5 &&
                        _vm.filteredOptions.filter((o) => o.type === 1)
                          .length === 1
                          ? _vm.select(
                              _vm.filteredOptions.filter((o) => o.type === 1)[0]
                            )
                          : undefined /*prevent submission when embedded in a form*/
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.inputValue = $event.target.value
                    },
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "menu-body" }, [
            _c(
              "ul",
              { staticClass: "menu-options" },
              [
                !_vm.filteredOptions.length
                  ? _c("li", { staticClass: "menu-option disabled" }, [
                      _c("em", {
                        staticClass: "menu-value",
                        domProps: {
                          innerHTML: _vm._s(_vm.noOptionsPlaceholder),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.filteredOptions, function (o) {
                  return [
                    o.type === 1
                      ? _c(
                          "li",
                          {
                            key: o.id,
                            class: {
                              "menu-option": true,
                              active:
                                !_vm.multiple && _vm.internalModel[o.value],
                              checked:
                                _vm.multiple && _vm.internalModel[o.value],
                              disabled: o.disabled,
                            },
                            attrs: {
                              tabindex: o.disabled ? undefined : -1,
                              title: o.title,
                              "data-value": o.value,
                            },
                            on: {
                              click: function ($event) {
                                _vm.select(o)
                                _vm.emitChangeOnClose = true
                              },
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  _vm.select(o)
                                  _vm.emitChangeOnClose = true
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  _vm.select(o)
                                  _vm.emitChangeOnClose = true
                                },
                              ],
                            },
                          },
                          [
                            _vm.allowHtml || !o.label || !o.label.trim()
                              ? _c("span", {
                                  staticClass: "menu-value",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      o.label && o.label.trim()
                                        ? o.label
                                        : "&nbsp;"
                                    ),
                                  },
                                })
                              : _c("span", { staticClass: "menu-value" }, [
                                  _vm._v(_vm._s(o.label || " ")),
                                ]),
                            _vm._v(" "),
                            _vm.multiple && _vm.internalModel[o.value]
                              ? _c("span", {
                                  staticClass: "menu-icon fa fa-check",
                                })
                              : _vm._e(),
                          ]
                        )
                      : o.type === 2
                      ? _c(
                          "li",
                          {
                            key: o.id,
                            class: {
                              "menu-group": true,
                              disabled: o.disabled,
                            },
                            attrs: { title: o.title },
                          },
                          [
                            _vm.allowHtml
                              ? _c("span", {
                                  staticClass: "menu-value",
                                  domProps: { innerHTML: _vm._s(o.label) },
                                })
                              : _c("span", { staticClass: "menu-value" }, [
                                  _vm._v(_vm._s(o.label || " ")),
                                ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }